var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99.999995,
    height: 99.999995,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", {
    fill: "#707070"
  }, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    strokeWidth: 3.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "rect4208",
    d: "m20,0c-11.08001,0 -20,8.91999 -20,20l0,60c0,11.08001 8.91999,20 20,20l60,0c11.08001,0 20,-8.91999 20,-20l0,-60c0,-11.08001 -8.91999,-20 -20,-20l-60,0zm-1.37305,21.0957l62.7461,0c3.64152,0 6.68164,3.04208 6.68164,6.6836l0,44.44336c0,3.64152 -3.04012,6.68164 -6.68164,6.68164l-62.7461,0c-3.64152,0 -6.68164,-3.04012 -6.68164,-6.68164l0,-44.44336c0,-3.64152 3.04012,-6.6836 6.68164,-6.6836zm4.02539,7l27.35157,28.31055l27.47461,-28.31055l-54.82618,0zm-3.70703,3.35938l0,36.43945l17.90625,-17.90625l-17.90625,-18.5332zm62.10938,0.13476l-18.00391,18.55079l18.00391,18.0039l0,-36.55469zm-40.72852,21.99414l-18.32031,18.32032l55.73828,0l-18.17578,-18.17578l-7.77344,8.01171a2.50025,2.50025 0 0 1 -3.59375,-0.0039l-7.875,-8.15235z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4be988938b17e453b63de20622c001bb.svg";
export { ForwardRef as ReactComponent };